import React from "react";

class Home extends React.Component {
  render() {
    return (
      <>
        <div className="app">
          <div className="container top">
            <h1>Welcome to Renaissance</h1>
          </div>
        </div>
      </>
    );
  }
}

export default Home;
